
/* injects from baggage-loader */

'use strict';

const marginDirectiveModule = angular.module('margin.setting', []);

marginDirectiveModule.directive('marginSetting', [
  '$window', '$timeout', '$compile', '$templateCache', ($window, $timeout, $compile, $templateCache) => {
    return {
      restrict: 'A',
      scope: {
        data: '=ngModel',
        afterChange: '&'
      },
      templateUrl: settingFolder + '/margin/template.jade',
      link: function(scope, element, attrs, ngModel) {
        var listener, marginSplit;

        if (!scope.data) {
          scope.data = '0 auto';
        }

        marginSplit = scope.data.split(' ');

        const top = parseInt(marginSplit[0]);
        const right = parseInt(marginSplit[1]);
        const bottom = parseInt(marginSplit[2] || marginSplit[0]);
        const left = parseInt(marginSplit[3] || marginSplit[1]);

        scope.margin = {
          top: isNaN(top) ? '' : top,
          right: isNaN(right) ? '' : right,
          bottom: isNaN(bottom) ? '' : bottom,
          left: isNaN(left) ? '' : left,
        };

        listener = scope.$watchCollection('margin', function(newVal) {
          const top = (newVal.top !== '' && newVal.top !== null) ? `${newVal.top}%` : 'auto';
          const right = (newVal.right !== '' && newVal.right !== null) ? `${newVal.right}%` : 'auto';
          const bottom = (newVal.bottom !== '' && newVal.bottom !== null) ? `${newVal.bottom}%` : 'auto';
          const left = (newVal.left !== '' && newVal.left !== null) ? `${newVal.left}%` : 'auto';

          scope.data = `${top} ${right} ${bottom} ${left}`;

          if (scope.afterChange) {
            scope.afterChange();
          }
        });

        scope.$on('$destroy', function() {
          listener();
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/margin/margin.directive.js